import {
  resolveViewerChromeSession,
  viewerAuthenticatedCookieName,
  viewerAvatarUrlCookieName,
  viewerDisplayNameCookieName,
  viewerMembershipPlanCookieName,
  type ViewerChromeSession,
} from "@dj/profile-chrome";

export * from "@dj/profile-chrome";

function readCookieValue(cookieHeader: string, name: string): string | undefined {
  const prefix = `${name}=`;
  const rawValue = cookieHeader
    .split(";")
    .map((part) => part.trim())
    .find((part) => part.startsWith(prefix))
    ?.slice(prefix.length);

  if (!rawValue) return undefined;

  try {
    return decodeURIComponent(rawValue);
  } catch {
    return undefined;
  }
}

/**
 * Rehydrates presentation-only account chrome after returning from react-web.
 * These cookies never authorize routes or private data.
 */
export function resolveViewerChromeSessionFromCookieHeader(
  cookieHeader: string,
): ViewerChromeSession {
  return resolveViewerChromeSession({
    authenticatedCookieValue: readCookieValue(cookieHeader, viewerAuthenticatedCookieName),
    avatarUrlCookieValue: readCookieValue(cookieHeader, viewerAvatarUrlCookieName),
    displayNameCookieValue: readCookieValue(cookieHeader, viewerDisplayNameCookieName),
    membershipPlanCookieValue: readCookieValue(cookieHeader, viewerMembershipPlanCookieName),
  });
}
